import { defineStore } from "pinia";

import { useEntityStore, useSelectEntityStore } from "@/shared";

import { getRights, editRights } from "../../user";
import { createEmployee } from "../api/createEmployee";
import { deleteEmployee } from "../api/deleteEmployee";
import { deleteEmployees } from "../api/deleteEmployees";
import { editEmployee } from "../api/editEmployee";
import { exportEmployees } from "../api/exportEmployees";
import { getEmployee } from "../api/getEmployee";
import { getEmployees } from "../api/getEmployees";
import { getEmployeesWithDirector } from "../api/getEmployeesWithDirector";

export const useEmployeesStore = defineStore("employees", () => {
    const {
        isManyLoading,
        manyError,
        isOneLoading,
        listData,
        singleData,
        meta,
        permissions,
        addOne,
        deleteOne,
        deleteMany,
        editOne,
        fetchMany,
        getOne,
        fetchRights,
        updateRights,
        exportMany,
        setManyLoading,
    } = useEntityStore({
        addEntity: createEmployee,
        getEntities: getEmployees,
        getEntity: getEmployee,
        deleteEntity: deleteEmployee,
        deleteEntities: deleteEmployees,
        editEntity: editEmployee,
        exportEntities: exportEmployees,
        getRights,
        editRights,
    });

    const { selectData, selectMeta, isSelectLoading, fetchSelect } =
        useSelectEntityStore({
            getEntities: getEmployeesWithDirector,
        });

    return {
        // entity
        listData,
        singleData,
        isManyLoading,
        manyError,
        isOneLoading,
        meta,
        permissions,
        fetchMany,
        getOne,
        addOne,
        deleteOne,
        deleteMany,
        editOne,
        fetchRights,
        updateRights,
        exportMany,
        setManyLoading,

        // select
        selectData,
        selectMeta,
        isSelectLoading,
        fetchSelect,
    };
});
